import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      whatYouGetBanner: {
        expandedEquation: {
          ...defineMessages({
            memberPurchases: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.memberPurchases',
              defaultMessage: 'Member purchases a credit package of',
            },
            toContribute: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.toContribute',
              defaultMessage: 'to contribute for you',
            },
            traffic: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.traffic',
              defaultMessage: 'Traffic investment',
            },
            fees: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.fees',
              defaultMessage: 'Processing fees and taxes',
            },
            shareCosts: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.shareCosts',
              defaultMessage: 'To share after costs',
            },
            ljShare: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.ljShare',
              defaultMessage: 'LiveJasmin share',
            },
            earnUpTo: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.earnUpTo',
              defaultMessage: 'Earn up to',
            },
            extra: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.extra',
              defaultMessage: 'Extra',
            },
            referralBonus: {
              id: 'pages.landing.whatYouGetBanner.expandedEquation.referralBonus',
              defaultMessage: 'Referral bonus',
            },
          }),
        },
      },
    },
  },
};
